/**
 * Calculates the coordinates of the child relative to its parent.
 * Note: using getBoundingClientRect() takes CSS transforms into calculations.
 */
export function getRelativeBoundsTo(child: Element, parent?: Element): ClientRect {
	const parentElement = parent || (child.parentNode as HTMLElement);
	const parentPos: ClientRect = parentElement.getBoundingClientRect();
	const childPos: ClientRect = child.getBoundingClientRect();

	return {
		top: childPos.top - parentPos.top,
		right: childPos.right - parentPos.right,
		bottom: childPos.bottom - parentPos.bottom,
		left: childPos.left - parentPos.left,
		width: childPos.width,
		height: childPos.height
	};
}

/**
 * Returns the coordinates of the child relative to a given parent in percent.
 */
export function getCoordinatesInPercent(svgPlaceHolder: Element, context: Element): { left: string; top: string } {
	const relativeBounds = getRelativeBoundsTo(svgPlaceHolder, context);

	return {
		left: `${(relativeBounds.left / context.getBoundingClientRect().width) * 100}%`,
		top: `${(relativeBounds.top / context.getBoundingClientRect().height) * 100}%`
	};
}
